import { render, staticRenderFns } from "./Recaptcha.vue?vue&type=template&id=7b903f01&"
import script from "./Recaptcha.vue?vue&type=script&lang=ts&"
export * from "./Recaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports